const nominowChartDefaults = require('./nominow-chart-defaults.js');

(function () {
	Vue.component('nominow-chart-heatmap', {
		mixins: [nominowChartDefaults.mixin],
		template: `<div :id="id"></div>`,
		props: {
			init: {
				type: Object,
				required: true
			},
			chartData: {
				type: Object,
				required: true
			},
			chartRequest: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				id: 'nncharttable-' + new Date().getTime(),
				chart: null
			}
		},
		created: function () {
			vuelog('heatmap', this.init, this.chartData, this.chartRequest);
			Vue.nextTick(() => {
				this.setupChart();
			});
		},
		methods: {
			setupChart: function () {
				const xCategories = [];
				const yCategories = [];
				const data = [];
				const colors = window.getPositiveToNegativeColors(xCategories.length);

				for (var el in this.chartData) {
					if (el.startsWith('Dimension')) {
						xCategories.push({ KPIName: this.chartData[el][0].Tag, KPICode: el });
					}
				}
				for (var el in this.chartData.Kpi) {
					const kpi = this.chartData.Kpi[el];
					const fact = this.init.SelectedFacts.find((f) => f.key == kpi.KPICode) || {};
					xCategories.push({ KPIName: kpi.KPIName, KPICode: kpi.FactNumber, Min: fact.min, Max: fact.max });
				}
				for (var rowIx = 0; rowIx < this.chartData.Values.length; rowIx++) {
					var row = this.chartData.Values[rowIx];
					yCategories.push(rowIx + 1);
					for (var colIx = 0; colIx < xCategories.length; colIx++) {
						var column = xCategories[colIx];
						data.push({
							x: colIx,
							y: rowIx,
							value: row[column.KPICode],
							color: this.determineColorFor(rowIx, column.Min, column.Max, row[column.KPICode], colors)
						})
					}
				}
				//vuelog('new table', xCategories, yCategories);
				const marginTop = 100;
				const marginBottom = 40;
				const chartHeight = yCategories.length * 30 + marginTop + marginBottom;

				this.chart = Highcharts.chart(this.id, $.extend(true, {}, this.chartDefaults(), {
					chart: {
						type: 'heatmap',
						marginTop: marginTop,
						marginBottom: marginBottom,
						plotBorderWidth: 1,
						plotBorderColor: globalColors.primary.hue6,
						backgroundColor: 'transparent',
						height: chartHeight
					},
					xAxis: {
						categories: xCategories.map(el => el.KPIName),
						min: 0,
						opposite: true,
						lineColor: globalColors.primary.hue6,
						tickColor: globalColors.primary.hue6,
						max: xCategories.length - 1,
						title: {
							text: null,
							style: {
								color: '#FFFFFF'
							}
						},
						labels: {
							style: {
								color: '#FFFFFF'
							}
						}
					},
					yAxis: {
						categories: yCategories,
						reversed: true,
						title: {
							text: null,
							style: {
								color: '#FFFFFF'
							}
						},
						labels: {
							style: {
								color: '#FFFFFF'
							}
						}
					},
					tooltip: {
						useHTML: true,
						outside: true,
						backgroundColor: globalColors.primary.hue9,
						formatter: function () {
							const kpi = xCategories[this.point.x];
							const min = kpi.Min;
							const max = kpi.Max;
							const rowTitle = 'Column';
							const rowVar = this.series.xAxis.categories[this.point.x] != undefined ? this.series.xAxis.categories[this.point.x] : this.point.x;
							const colTitle = 'Row';
							const colVar = this.series.yAxis.categories[this.point.y] != undefined ? this.series.yAxis.categories[this.point.y] : this.point.y;
							return `${rowTitle}: <b>${rowVar}</b><br/>${colTitle}: <b>${colVar}</b><br/>${min != undefined ? `Min: <b>${min}</b><br/>` : ''}${max != undefined ? `Max: <b>${max}</b>` : ''}`;
						}
					},
					series: [
						{
							borderWidth: 0,
							data: data,
							dataLabels: {
								enabled: true,
								color: '#FFFFFF'
							}
						}
					],
					plotOptions: {
						series: {
							dataLabels: {
								enabled: true,
								style: {
									textShadow: false,
									textOutline: false,
									color: '#f0f'
								}
							}
						},
						heatmap: {
							states: {
								hover: {
									brightness: 0.1
								}
							}
						}
					},
				}));
				this.$emit('chartReady', this.chart);
			},
			determineColorFor: function (index, minInit, maxInit, valueInit, colors) {
				//console.log('determineColorFor', index, minInit, maxInit, valueInit)
				const rowbgeven = globalColors.other['table-row-even'];
				const rowbgodd = globalColors.other['table-row-odd'];
				if (valueInit == undefined || isNaN(valueInit) || isNaN(minInit) || isNaN(maxInit) || minInit == null || maxInit == null || minInit == '' || maxInit == '') {
					return index % 2 == 0 ? rowbgeven : rowbgodd;
				}

				//times 100 to make franctional values work better ie 0.1 ==> 10
				let min = minInit * 10;
				let max = maxInit * 10;
				let value = valueInit * 10;



				// If the min is higher than the max, switch the values so we can use the same for loop
				const reverse = min > max;
				min = reverse ? max : min;
				max = reverse ? min : max;
				// This is the total spread between the min and the max
				const totalvariation = max - min;

				// With the total spread and the amount of colors, we decide on the stopsize in which to categorize the colors
				const stopsize = totalvariation / colors.length;
				//console.log('determine color', index, code, min, max, value, stopsize, colors)
				// Loop through every color
				for (let i = 0; i < colors.length; i++) {
					// Set the min and max for this color
					const cmin = min + stopsize * (i + 1) - stopsize;
					const cmax = min + stopsize * (i + 2) - stopsize;
					// If this color is...
					let isabovemin;
					let iswithinmax;
					if (reverse) {
						// If it's the first one, then anything below min is also included
						isabovemin = i == 0 ? true : value >= cmin;
						// If it's the last one, then anything above max is also included
						iswithinmax = i == colors.length - 1 ? true : value < cmax;
					} else {
						// If it's the first one, then anything below min is also included
						isabovemin = i == 0 ? true : value > cmin;
						// If it's the last one, then anything above max is also included
						iswithinmax = i == colors.length - 1 ? true : value <= cmax;
					}

					if (isabovemin && iswithinmax) {
						// If we're in reverse, make sure to reverse the color axis so we pass the right colors
						if (reverse) {
							const arr = colors.slice().reverse(); // good to bad
							return arr[i];
						}
						return colors[i]; // bad to good
					}
				}
			}
		}
	})
})();
